import React, {Component} from "react";
import {Link} from "react-router-dom";
import {Alert} from "../../alertServices";
import { post } from '../../networking/Api';
import Constent from '../../networking/Constent';
import ReactCodeInput from 'react-code-input';
import { withTranslation } from 'react-i18next';
import "../../Auth.css";

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/placeholder.png';

const props = {
  className:'pw',
  inputStyle: {
    fontFamily: 'monospace',
    margin:  '4px',
    MozAppearance: 'textfield',
    width: '50px',
    borderRadius: '8px',
    fontSize: '25px',
    height: '50px',
    backgroundColor: 'unset',
    color: '#ffffff',
    border: '1px solid #0080FF',
    outline: "none",
    textAlign: "center"
  },
  inputStyleInvalid: {
    fontFamily: 'monospace',
    margin:  '4px',
    MozAppearance: 'textfield',
    width: '45px',
    borderRadius: '8px',
    fontSize: '14px',
    height: '45px',
    backgroundColor: 'unset',
    color: '#ffffff',
    border: '1px solid #0080FF',
    outline: "none",
    textAlign: "center"
  }
}

class PinVerification extends Component {
    state={
        pin:'',
        userId:'',
        language:'Danish'
    }
    componentDidMount(){
        document.getElementById("body").classList.add("bg-theme");
        var userid = localStorage.getItem('userid');
        if( (userid  === null) || (userid  === 'null') ){
          this.props.history.push('/signin')
        }

        let is_user_login = localStorage.getItem('is_user_login');
        if( (is_user_login === 'true' || is_user_login === true)){
            this.props.history.push('/');
        }

        var lng = localStorage.getItem('defaultLng');
        if( (lng  !== null) && (lng  !== 'null') ){
          this.setState({language:lng})
        }
    }

    changeLanguage(lng){
        localStorage.setItem('defaultLng',lng);
        this.setState({language:lng})
        if( (lng === 'en') || (lng === 'English')) {
            lng = 'en';
        }else if( (lng === 'dk') || (lng === 'Danish') ){
            lng = 'dk';
        }else if( (lng === 'fr') || (lng === 'French') ){
            lng = 'fr';
        }else if( (lng === 'tr') || (lng === 'TR') ){
            lng = 'tr';
        }else if( (lng === 'hi') || (lng=== 'Hindi') ){
            lng = 'hi';
        }else{
            lng = 'dk';
        }                           
       const {  i18n } = this.props;
       i18n.changeLanguage(lng);
       localStorage.setItem('lng',lng);
    }

    onSubmit = (finalpin) => {
           var formData = new FormData();
           formData.append("user_id",localStorage.getItem('userid'));
           formData.append("pin",finalpin);
           formData.append('fcm_id',localStorage.getItem('fcm_id'));
           post(Constent.PIN,formData).then(response=>{
              if(response.status===1){
                localStorage.setItem('is_user_login',true);

                localStorage.setItem('menu_permission', JSON.stringify(response.menu_permission));
                localStorage.setItem('department_id',response.department_id);
                // localStorage.setItem('group_name',response.group_name);
                // localStorage.setItem('company_name', response.company_name);
                localStorage.setItem('department_name', response.department_name);
                localStorage.setItem('user_data', JSON.stringify(response.user_data));
                 localStorage.setItem('timestamp_option',JSON.stringify(response.timestamp_option));
                localStorage.setItem('department_list',JSON.stringify(response.department_list));
                this.changeLanguage(response.user_data.default_language);
              //  localStorage.setItem('emp_edit',JSON.stringify(response.timestamp_option.emp_edit));
               // localStorage.setItem('checkin_with_time',JSON.stringify(response.timestamp_option.checkin_with_time));
               // localStorage.setItem('checkin_with_project',JSON.stringify(response.timestamp_option.checkin_with_project));
               // localStorage.setItem('checkin_with_shift',JSON.stringify(response.timestamp_option.checkin_with_shift));
                
              //  localStorage.setItem('checkin_with_flex',JSON.stringify(response.timestamp_option.checkin_with_flex));
              //  localStorage.setItem('flex_see_schema',JSON.stringify(response.timestamp_option.flex_see_schema));
               // localStorage.setItem('flex_addedit_schema',JSON.stringify(response.timestamp_option.flex_addedit_schema));
              //  localStorage.setItem('flex_addedit_record',JSON.stringify(response.timestamp_option.flex_addedit_record));
                  localStorage.setItem('user_type', response.user_data.user_type);

                localStorage.setItem('diff','00:00');
                localStorage.setItem('ruleMeetTime','');
                localStorage.setItem('checkInStatus',true);
                localStorage.setItem('checkin_projectid',"0");
                this.props.history.push('/')
              }else{
                Alert.error({title: response.message});
              }
           })
       }

    render() {
        const { t } = this.props;
        return (
            <div className="signin-area">
            <div className="row">
              <div className="col-sm-12 col-12">
                <select className="language" value={this.state.language}
                    onChange={e => { this.changeLanguage(e.target.value) }}>
                    <option value="Danish">{t('lang.language_text_danish')}</option>
                    <option value="English">{t('lang.language_text_english')}</option>
                    <option value="French">{t('lang.language_text_french')}</option>
                    <option value="TR">{t('lang.language_text_tr')}</option>
                </select>
              </div>
              <div className="col-sm-12 col-12 text-center">
                <img className="userimage" src={ ((localStorage.getItem('profile_image') != null) && (localStorage.getItem('profile_image').length===0)) ? dummyImage :localStorage.getItem('profile_image')} alt="logo" style={{ width: 100,height: 100}} />
              </div>
            </div>
              <div className="container">
                <p className="title"><span>{t('lang.auth_sc_hi')}</span> {localStorage.getItem('username')}!</p>
                  <form className="contact-form-inner">
                        <p className="insert-pin-text">{t('lang.auth_sc_insert_your_pin')}</p>
                        <ReactCodeInput  
                            type='password' 
                            fields={4} 
                            inputMode='numeric' 
                            pattern="^-?[0-9]\d*\.?\d*$" 
                            {...props}
                            onChange={value=>{
                              this.setState({pin:value})
                              if(value.length===4){
                                this.onSubmit(value)
                              }
                            }}
                            autoFocus={true}
                          />
                            <br></br><br></br>
                        <Link className="forgot-btn" to={'/forgot-pin-signin'}>{t('lang.auth_sc_forget_my_pin')}?</Link>
                    </form>
              </div>
          </div>
        );
    }
}

export default (withTranslation('common')(PinVerification));